import MultiTagInput from './multi-tag-input'

export default MultiTagInput